import { render, staticRenderFns } from "./ClientDownload.vue?vue&type=template&id=f18501a6"
import script from "./ClientDownload.vue?vue&type=script&lang=js"
export * from "./ClientDownload.vue?vue&type=script&lang=js"
import style0 from "./ClientDownload.vue?vue&type=style&index=0&id=f18501a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports